<template>
  <eg-b-form-group>
    <div class="d-flex">
      <ToggleButton
        v-for="radioOption in radioOptions"
        :key="radioOption.value"
        class="mr-3 btn d-flex align-center"
        :horizontal="true"
        :value="radioOption.value"
        :label="$t(radioOption.translationKey)"
        :pressed="value === radioOption.value"
        @click="handleChange(radioOption.value)"
      />
    </div>
  </eg-b-form-group>
</template>

<script>
import ToggleButton from "@/components/global/eg_toggle_button.vue";
import { FEEDBACK_LENGTH } from "@/constants";

export default {
  components: { ToggleButton },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      radioOptions: FEEDBACK_LENGTH,
    };
  },
  methods: {
    handleChange(valueId) {
      this.$emit("input", valueId);
    },
  },
};
</script>
